// import Chart from 'chart.js/auto';
// import 'chart.js/auto';
// import { FunnelChart } from 'chartjs-chart-funnel';
// import ChartDataLabels from 'chartjs-plugin-datalabels';
// import 'htmx.org';
//
// (async function() {
//     // htmx.on("htmx:afterSettle", function(){
//     document.body.addEventListener("htmx:afterSettle", function() {
//         let funneldata = JSON.parse(document.getElementById('funnelchartconfig').textContent);
//
//         new FunnelChart(
//             document.getElementById('funnelchart'),
//             {
//                 type: 'funnel',
//                 data: {
//                     labels: ['Ad Impressions', 'Aufrufe Detailseite', 'Nutzer', 'Leads'],
//                     datasets: [
//                         {
//                             // label: 'Pageviews',
//                             // data: data.map(row => row.pageviews)
//                             data: funneldata,
//                             datalabels: {
//                                 // formatter: (v) => v.toLocaleString(),
//                                 anchor: (context) => {
//                                     const value = context.dataset.data[context.dataIndex];
//                                     return value < 0.02 ? 'end' : 'start';
//                                 },
//                                 align: (context) => {
//                                     const value = context.dataset.data[context.dataIndex];
//                                     return value < 0.02 ? 'end' : 'center';
//                                 },
//                                 textAlign: 'center',
//                                 color: (context) => {
//                                     return '#000000';
//                                 },
//                                 font: {
//                                     size: 20,
//                                 },
//                                 formatter: (value, context) => {
//                                     const label = context.chart.data.labels[context.dataIndex];
//                                     return `${label}\n${(value).toLocaleString()}`;
//                                 }
//                             },
//                             // borderColor: 'rgb(75, 192, 192)',
//                             // backgroundColor: 'rgb(211,211,211)',
//                         }
//                     ]
//                 },
//                 options: {
//                     indexAxis: 'y',
//                 },
//                 plugins: [ChartDataLabels],
//             }
//         );
//         // if(Chart.getChart("funnelchart")) {
//         //     Chart.getChart("funnelchart")?.destroy()
//         // }
//     })
// })();
